/* Forma del formulario de publicación, la misma para crear, editar y el paso
 * "Publicar" del alta. `media` es un único array de {url, type, format,
 * public_id}, como en el formulario de eventos. */

export const LIMITES = {
  TITULO_MIN: 5,
  TITULO_MAX: 50,
  DESCRIPCION_MIN: 5,
  DESCRIPCION_MAX: 80,
};

export const publicacionVacia = () => ({
  id: null,
  titulo: "",
  descripcion: "",
  desde: "", // "YYYY-MM-DDTHH:mm" en hora de Argentina
  hasta: "",
  media: [],
});
